import React, { useState } from "react";
import { Card } from "./ui/card";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Button } from "./ui/button";

function Login({ onLogin, isLoading }) {
  const [inputValue, setInputValue] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (inputValue) {
      onLogin(inputValue);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-slate-50">
      <Card className="max-w-md w-full p-8 md:p-10 shadow-float border-0 bg-white overflow-hidden relative">
        <div className="absolute top-0 left-0 w-1 h-full bg-slate-600" />

        <div className="mb-10 text-center">
          <h1 className="text-2xl font-black text-slate-900 tracking-tight uppercase italic">
            Acesso <span className="text-slate-600">Restrito</span>
          </h1>
          <p className="text-slate-500 text-xs font-medium mt-1">Insira suas credenciais para continuar</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="space-y-2">
            <Label
              htmlFor="login-input"
              className="text-[11px] font-bold text-slate-400 uppercase tracking-widest pl-1"
            >
              CPF ou Senha de Acesso
            </Label>
            <Input
              type="text"
              id="login-input"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              placeholder="000.000.000-00"
              disabled={isLoading}
              className="border-2 border-slate-100 focus:border-blue-800 transition-all h-12 text-slate-900 font-medium focus:ring-4 focus:ring-blue-800/5"
            />
          </div>
          <Button
            type="submit"
            disabled={isLoading}
            className="w-full h-12 text-sm font-black bg-slate-900 hover:bg-slate-800 text-white shadow-lg transition-all active:scale-[0.98] uppercase tracking-widest"
          >
            {isLoading ? (
              <span className="inline-flex items-center gap-2">
                <svg
                  className="animate-spin h-5 w-5 text-blue-800"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                  ></path>
                </svg>
                Validando...
              </span>
            ) : (
              "Entrar no Sistema"
            )}
          </Button>
        </form>
      </Card>
    </div>
  );
}

export default Login;
